import React, { useRef, useState, useEffect, Fragment } from "react";
import * as yup from "yup";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { Report, TonnageDisclaimer } from "../../../shared";

const schema = yup.object({
  shipYear: yup.string().required("A Ship Year is required."),
});

export default function TannerReportRegulatory() {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = Object.keys(params).length > 0 ? true : false;
  const [initialFormValues, setInitialFormValues] = useState({
    shipYear: params && params.shipYear ? params.shipYear : "",
  });
  const [backToUrl, setBacktoUrl] = useState("/reports");
  const [pageTitle, setPageTitle] = useState("Tanner Report (Regulatory)");
  const [apiEndpoint, setApiEndpoint] = useState(
    "/api/v1/hwts/search/tannerreport/cdtfa"
  );
  const formRef = useRef();

  const formConfig = [
    {
      name: "shipYear",
      config: {
        col: "md",
        validate: true,
        colWidth: "2",
        label: "Ship Year",
        placeholder: "Select a Year",
        type: "prevYears",
        yearStart: 2010,
      },
    },
  ];

  const customGridCells = [
    {
      columnName: "EPA_ID",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      columnName: "Manifest_Tonnage",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/reports/manifest?epaId=${params.data.EPA_ID}&shipYear=${formRef.current.values.shipYear}&entityType=Generator" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      columnName: "TQR_Tonnage",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/reports/tqr-detail-report?epaId=${params.data.EPA_ID}&fromDate=${formRef.current.values.shipYear}-01-01&toDate=${formRef.current.values.shipYear}-12-31&entityType=Generator" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
  ];

  return (
    <Fragment>
      <Report
        breadcrumb={[
          { name: "HWTS Reports", url: "/reports", active: false },
          { name: "Tanner Report (Regulatory)", url: "", active: true },
        ]}
        backToUrl={backToUrl}
        pageTitle={pageTitle}
        initialFormValues={initialFormValues}
        schema={schema}
        formConfig={formConfig}
        customGridCells={customGridCells}
        apiEndpoint={apiEndpoint}
        formRef={formRef}
        searchOnInit={searchOnInit}
      />
      <div className="container">
        <TonnageDisclaimer />
      </div>
    </Fragment>
  );
}
